<template>
	<component
		class="icon-svg"
		v-bind="iconProps"
		:is="iconComponent"
		@click="$emit('click', $event)"
	/>
</template>

<script>
// IMPORTANT!!! Only for icons in the assets/svg
const icons = {}

const requireComponents = require.context('../assets/svg', true, /.svg$/)

requireComponents.keys().forEach(fileName => {
	const iconName = fileName.replace(/^\.\/(.+)\.svg$/, '$1')
	const componentConfig = requireComponents(fileName)
	icons[iconName] = componentConfig.default || componentConfig
})

export default {
	name: 'IconSvg',

	props: {
		icon: {
			type: String,
			required: true
		},

		color: {
			type: String,
			default: ''
		},

		fill: {
			type: String,
			default: ''
		},

		width: {
			type: [Number],
			default: 0
		},

		height: {
			type: [Number],
			default: 0
		},
		viewBox: {
			type: String,
			default: ''
		}
	},

	computed: {
		iconComponent() {
			if (!icons[this.icon]) {
				console.warn(`Could not find icon name=${this.icon}`)
			}

			return icons[this.icon]
		},

		iconProps() {
			const formattedProps = {}

			Object.keys(this.$props).forEach(key => {
				const value = this.$props[key]
				if (key !== 'icon' && value) {
					const formattedPropKey = key === 'color' ? 'stroke' : key
					formattedProps[formattedPropKey] = value
				}
			})

			return formattedProps
		}
	}
}
</script>

<style lang="scss" scoped>
.icon-svg {
	display: block;
}
</style>
